// One owner-approved, public form for panel selection and optimization intake.
const activationUrl = new URL(process.env.REACT_APP_JOTFORM_INTAKE_URL);
const formId = activationUrl.pathname.replace(/^\/+|\/+$/g, '');
if (activationUrl.protocol !== 'https:' || !/^\d+$/.test(formId) || activationUrl.search || activationUrl.hash) {
  throw new Error('REACT_APP_JOTFORM_INTAKE_URL must be the HTTPS public form URL without prefill parameters.');
}

export const ACTIVATION_FORM_URL = activationUrl.href;
export const ACTIVATION_FORM_ORIGIN = activationUrl.origin;
export const ACTIVATION_FORM_ID = formId;
export const ACTIVATION_FORM_TITLE = 'Integrated Wellness Optimization Activation';
export const ACTIVATION_PAGE = '/order';